export class Event {
    badge: boolean;
    email: boolean;
    eventDescription: string;
    eventId: string;
    eventName: string;
    frequencyMode: string;
    frequencyTime: string;
    deliveryDay:string;
    sMS: boolean;
    id: string;
    notificationType: string;
    timeZoneArea: string;
    canUserEdit:boolean;
}